import * as React from 'react';
import { DigitalMapPin } from 'models/digitalMap';
import { AdvancedMarker } from './AdvancedMarker';
import { useMapDisplayContext } from './MapDisplayContext';
import { smoothMoveCamera } from './mapUtils';
import { PinDisplay } from './PinDisplay';
import Map from 'ol/Map';

interface Props {
  map: google.maps.Map | Map;
  pin: DigitalMapPin;
  isActive: boolean;
  onClick?: (pinKey: string) => void;
}

export const PinMarker = React.forwardRef<google.maps.marker.AdvancedMarkerElement, Props>(
  ({ map, pin, isActive, onClick }, ref) => {
    const { activePage } = useMapDisplayContext();

    const clickHandler = (e: Event) => {
      e.stopPropagation();
      onClick?.(pin.key);
      if (!activePage.startsWith('ITINERARIES')) {
        const isGoogleMap = map instanceof google.maps.Map;
        smoothMoveCamera(isGoogleMap ? map : null, !isGoogleMap ? (map as Map) : null, {
          center: {
            lat: pin.location?.latitude ?? 0,
            lng: pin.location?.longitude ?? 0,
          },
        });
      }
    };

    return (
      <AdvancedMarker
        ref={ref}
        key={pin.index}
        map={map instanceof google.maps.Map ? map : null}
        position={{
          lat: pin.location?.latitude ?? 0,
          lng: pin.location?.longitude ?? 0,
        }}
        onClick={clickHandler}
        zIndex={isActive ? 2 : 1}
      >
        <PinDisplay pin={pin} isActive={isActive} />
      </AdvancedMarker>
    );
  }
);
